import React, { useCallback } from 'react'
import { Separator } from '../separator'
import { Radio } from '../form'
import { MandatoryText } from './../text/mandatory-text';
import { Properties } from '../../models/polymer/Properties.model';
import { PolymerCrypto } from '../../utils/encryptor';
import { useAppDispatch, useAppSelector } from '../../redux/hook';
import { updateLoginUser } from '../../redux/slices/authentication-slice';

interface AddressSelectionProps extends React.HtmlHTMLAttributes<HTMLDivElement>{
  onItemSelect?: (value:Properties) => void;
  value?: Properties;
  required?: boolean;
  header?:string[];
  items?:Properties[];
}

function AddressSelection({items=[], required=true,...props}:AddressSelectionProps) {
  const AppDispatch = useAppDispatch();
  const { loginUser } = useAppSelector((state) => state.auth.AuthenticationSlice);
  
  const handleSelection = useCallback((item: Properties) => () => {
    const representedOwner = item.getRepresentedOwner();
    if (representedOwner) {
      const decryptedUinfin = PolymerCrypto.decryption(representedOwner.uinfin);
      AppDispatch(updateLoginUser({...representedOwner, uinfin: decryptedUinfin}));
    } else {
      AppDispatch(updateLoginUser(loginUser));
    }
    props?.onItemSelect?.(item);
  },[AppDispatch, updateLoginUser]);


  return (
    <div style={{...props.style}}>
      <div className='polymer-address-selection'>
        <div className='polymer-address-selection__header-section' style={{ display: "flex", flexDirection: "row" }}>
          {props.header?.map((header_title,_index:number)=>{
            return (
              <div style={{ flex: 1 }} key={`${header_title}`} className={`${_index === 0 ? "polymer-address-selection__header-section-first": ""}`}>
                <p className='m-0' style={{paddingLeft:_index === 0 ?'39px' : undefined}}>{header_title}</p>
              </div>
            )
          })}
        </div>
        {
          items?.map((item,_index:number)=>{
            const key = _index;
            const representedOwner = item.getRepresentedOwner();
            return (
              <div key={key}>
                <Separator style={{ margin: "16px 0" }} />
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div className='polymer-address-selection__content-address' style={{ flex: 1 }}>
                    <div className='polymer-address-selection__content-address-div'>
                      <Radio isActive={JSON.stringify(props.value) === JSON.stringify(item)} onClick={handleSelection(item)} description={<p className='m-0'>{item.address}</p>} />
                    </div>
                  </div>
                  <div className='polymer-address-selection__content-role' style={{ flex: 1 }}>
                    {!representedOwner
                      ? item.current_user?.role_name
                      : `${item.current_user?.role_name} representing ${representedOwner.name} (${PolymerCrypto.decryption(representedOwner.uinfin)})`}
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
      {required && <div style={{marginTop:"16px"}}><MandatoryText/></div>}
    </div>
  )
}

export default AddressSelection